import { render, staticRenderFns } from "./Tabulator.vue?vue&type=template&id=fc6b98da&scoped=true&"
import script from "./Tabulator.vue?vue&type=script&lang=js&"
export * from "./Tabulator.vue?vue&type=script&lang=js&"
import style0 from "./Tabulator.vue?vue&type=style&index=0&id=fc6b98da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6b98da",
  null
  
)

export default component.exports